import { enum_ } from "valibot"

export enum ImpassValue {
  Passible = 0,
  Impassible = 1,
}

export const ImpassValueSchema = enum_(ImpassValue, 'Invalid Impass Value')
